import React from 'react';
import styled from 'styled-components';
import { Label } from '../../../shared/styled-components/styled_text';
import { LoginProvider } from '../../../common/providers_services/LoginProvider';

interface Props {
  id: string;
  provider: LoginProvider;
  onClick: () => void;
}

export const LoginButton: React.FC<Props> = ({ id, provider, onClick }) => {
  const getName = (p: LoginProvider) => (p === 'kakao' ? '카카오' : p === 'naver' ? '네이버' : p === 'google' ? '구글' : '애플');

  if (provider === 'naver') {
    return (
      <Wrapper>
        <Container as='button' type='button' provider={provider} onClick={onClick}>
          <img src={`/images/login/naver_logo.svg`} alt={`naver login`} style={{ width: '1.4rem', height: '1.4rem' }} />
          <Label size='m' style={{ color: `var(--social-btn-font-color-naver)` }}>
            네이버로 계속하기
          </Label>
        </Container>

        <div id={id} style={{ width: 0, height: 0, overflow: 'hidden' }} />
      </Wrapper>
    );
  }

  return (
    <Container as='button' id={id} type='button' onClick={onClick} provider={provider}>
      <img src={`/images/login/${provider}_logo.svg`} alt={`${provider} login`} style={{ width: '1.8rem', height: '1.8rem' }} />
      <Label size='m' style={{ color: `var(--social-btn-font-color-${provider})` }}>
        {getName(provider)}로 계속하기
      </Label>
    </Container>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.button<{ provider: LoginProvider }>`
  width: 100%;
  min-width: 8rem;
  height: 4.2rem;
  background-color: var(--social-btn-bg-${({ provider }) => provider});
  border: ${({ provider }) => (provider === 'google' ? '1px solid var(--border-color)' : 'none')};
  border-radius: 4px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
`;
